// extracted by mini-css-extract-plugin
export default {"root":"style_root__b2ygn","loader":"style_loader__vrCQx","load8":"style_load8__3OJUm"};